import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import "./fonts/fonts.css";
import "./global.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <div>
    <App />
  </div>
);